import React from 'react';
import defaultState from './defaultState';

export default React.createContext(defaultState);
